namespace $.$$ {
	export class $shm_surreal_sdk extends $.$shm_surreal_sdk {

		private static importer = new Function( 'url', 'return import(url)' ) as ( url: string )=> Promise< $shm_surreal_sdk_module >

		static override lib_async() {
			const url = new URL( '/shm/surreal/bundle/surrealdb.mjs', $mol_dom_context.location.origin ).toString()
			return this.importer( url )
		}
	}
}
